import type { Icon } from '../../../src/lib/types'
export const mdiArrowRight: Icon = {
  "id": "arrow-right",
  "name": "Arrow Right",
  "path": "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z",
  "as": [
    "arrow-forward"
  ],
  "tags": [
    "Arrow"
  ]
}
export default mdiArrowRight